import React from "react";
import contextProvider from "../../../contextProvider";
import { withRouter } from "react-router-dom";
import { Row, Col } from "reactstrap";

import _ReactOBaseComponent from "../../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../../_L0_components/Widgets/_LoadingKit";

import Panel from "../../../_L1_components/Layout/Panel";
import ReactOActionBar from "../../../_L1_components/Elements/ReactOActionBar";
import ReactOForm from "../../../_L1_components/Elements/ReactOForm";
import ReactOFormInput from "../../../_L1_components/Elements/ReactOFormInput";
import ReactOButton from "../../../_L1_components/Elements/ReactOButton";

class ProbeSetupEthernet extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      data: {},
      loading: false,
    };
    super(props, initState);
  }

  loadProbeSetup(cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        if (this.props.onConfLoad) {
          this.props.onConfLoad();
        }
        this.apiStore.fire("get_probe_setup_with_filter", {
          data: {
            probeuid: this.props.match.params.probeuid,
            entry_path: "ethernet",
          },
          ___onSuccess: (status, data) => {
            if (this.mounted) {
              this._probe_setup_form.init({
                ethernet: data,
              });
              this.setState({
                data: data,
                loading: false,
              });
            }
          },
        });
      }
    );
  }

  saveProbeSetup(data, cb) {
    //		console.log("DEBUG :: ProbeSetup _ saveProbeSetup");
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("set_probe_setup_with_filter", {
          data: {
            probeuid: this.props.match.params.probeuid,
            entry_path: "ethernet",
            value: data["ethernet"],
          },
          ___onSuccess: (status, data) => {
            this.setState(
              {
                loading: false,
              },
              () => {
                this.loadProbeSetup();
                if (cb) {
                  cb(status, data);
                }
              }
            );
          },
        });
      }
    );
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    //		console.log("DEBUG :: ProbeSetupEthernet _ onComponentDidMount");
    this.mounted = true;
    this.apiStore = this.getAppContext().getApiStoreService();
    this.loadProbeSetup();
  }

  onComponentWillUnmount() {
    this.mounted = false;
  }

  onRender() {
    return (
      <_LoadingWrapper loadingPlug={this.state.loading}>
        <Panel
          className="mb-4 rounded-bottom"
          //	header="Ethernet"
          style={{
            minHeight: "100px",
          }}
        >
          <ReactOForm
            onSubmit={this.saveProbeSetup.bind(this)}
            unsavedWarning={true}
            onControllerReady={(form_controller) => {
              this._probe_setup_form = form_controller;
            }}
            onFormDataChange={(form_data) => {
              this.forceUpdate();
            }}
          >
            <Row>
              <Col xs={12}>
                <Row className="mb-3">
                  <Col xs={12} sm={6} lg={3}>
                    <ReactOFormInput
                      type="select"
                      disabled={this.state.data.MEASURE_BLOCK}
                      data_key="ethernet.conf"
                      label="IP configuration"
                      size="md"
                      default="dhcp"
                      options={[
                        { name: "Disabled", value: "disabled" },
                        { name: "DHCP", value: "dhcp" },
                        { name: "Static", value: "static" },
                      ]}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={6} lg={3}>
                    <ReactOFormInput
                      type="text"
                      disabled={this.state.data.MEASURE_BLOCK}
                      data_key="ethernet.ip"
                      required
                      defineIf={(form_data) => {
                        return (
                          this._probe_setup_form.getEntry("ethernet.conf") == "static"
                        );
                      }}
                      label="IP address"
                      placeholder="e.g. 192.168.255.123"
                      size="md"
                      default=""
                      validators={[
                        {
                          func: (value) => {
                            return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i.test(
                              value
                            );
                          },
                          invalid_text: "Type a valid ip address",
                        },
                      ]}
                    />
                    <ReactOFormInput
                      className="mt-3 mt-sm-0"
                      type="text"
                      disabled={this.state.data.MEASURE_BLOCK}
                      data_key="ethernet.netmask"
                      required
                      defineIf={(form_data) => {
                        return (
                          this._probe_setup_form.getEntry("ethernet.conf") == "static"
                        );
                      }}
                      label="Netmask"
                      placeholder="e.g. 255.255.255.0"
                      size="md"
                      default=""
                      validators={[
                        {
                          func: (value) => {
                            return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i.test(
                              value
                            );
                          },
                          invalid_text: "Type a valid ip address",
                        },
                      ]}
                    />
                    <ReactOFormInput
                      className="mt-3 mt-sm-0"
                      type="text"
                      disabled={this.state.data.MEASURE_BLOCK}
                      data_key="ethernet.gateway"
                      required
                      defineIf={(form_data) => {
                        return (
                          this._probe_setup_form.getEntry("ethernet.conf") == "static"
                        );
                      }}
                      label="Gateway"
                      placeholder="e.g. 192.168.255.1"
                      size="md"
                      default=""
                      validators={[
                        {
                          func: (value) => {
                            return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i.test(
                              value
                            );
                          },
                          invalid_text: "Type a valid ip address",
                        },
                      ]}
                    />
                  </Col>
                  <Col xs={12} sm={6} lg={3}>
                    <ReactOFormInput
                      className="mt-3 mt-sm-0 mb-3 mb-sm-0"
                      type="array"
                      disabled={this.state.data.MEASURE_BLOCK}
                      data_key="ethernet.dns"
                      label="Dns"
                      defineIf={(form_data) => {
                        return (
                          this._probe_setup_form.getEntry("ethernet.conf") == "static"
                        );
                      }}
                      validators={[
                        {
                          func: (value) => {
                            return value.length > 0;
                          },
                          invalid_text: "Set at least 1 dns server",
                        },
                      ]}
                      onRender={(form_array_data, remove_action, add_action) => {
                        return (
                          <div>
                            {form_array_data.map((_CURR_entry, _CURR_idx) => {
                              return (
                                <ReactOFormInput
                                  key={_CURR_idx}
                                  type="text"
                                  disabled={this.state.data.MEASURE_BLOCK}
                                  data_key={"ethernet.dns." + _CURR_idx}
                                  className="mb-1"
                                  placeholder="e.g. 8.8.8.8"
                                  size="md"
                                  append={
                                    <ReactOButton
                                      onClick={() => {
                                        remove_action(_CURR_idx);
                                      }}
                                      icon="minus"
                                      color="gray200"
                                    />
                                  }
                                  validators={[
                                    {
                                      func: (value) => {
                                        return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i.test(
                                          value
                                        );
                                      },
                                      invalid_text: "Type a valid ip address",
                                    },
                                  ]}
                                />
                              );
                            })}
                            <ReactOActionBar key="2" align="right" padding="0px">
                              <ReactOButton
                                onClick={add_action}
                                icon="plus"
                                color="gray200"
                              />
                            </ReactOActionBar>
                          </div>
                        );
                      }}
                    />
                  </Col>
                </Row>

                {this.state.data.MEASURE_BLOCK ? (
                  <small className="text-muted d-flex align-items-center">
                    <span className="icon-info mr-1" style={{ fontSize: "130%" }} />
                    <strong className="mr-2">INACTIVE:</strong>
                    <span> Used by measure {this.state.data.MEASURE_BLOCK}</span>
                  </small>
                ) : null}
                <ReactOActionBar align="right" padding="0">
                  <ReactOFormInput type="submit" value="Save" color="primary" icon="save">
                    Save
                  </ReactOFormInput>
                </ReactOActionBar>
              </Col>
            </Row>
          </ReactOForm>
        </Panel>
      </_LoadingWrapper>
    );
  }
}

export default contextProvider(
  withRouter(ProbeSetupEthernet),
  //	withDefinedContext(ProbeSetupEthernet, 'ProbeSetupEthernet', context_exposed_methods),
  {
    define: null,
  }
);
